import { render } from "./CommentInput.vue.js?vue&type=template&id=f4d2f64e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentInput.vue?vue&type=template&id=f4d2f64e"
import script from "./CommentInput.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/comments-widget/CommentInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4d2f64e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4d2f64e', __exports__)) {
    api.reload('f4d2f64e', __exports__)
  }
  
  module.hot.accept("./CommentInput.vue.js?vue&type=template&id=f4d2f64e!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentInput.vue?vue&type=template&id=f4d2f64e", () => {
    api.rerender('f4d2f64e', render)
  })

}


export default __exports__